
export { useGeoLocationData } from "/vercel/path0/packages/utility-tools/module/location/hooks/useGeoLocationData.ts"